<span *ngIf="text && template === displayType.Badge" class="p-badge" [ngStyle]="{ 'color': color, 'border-color': color}">{{text}}</span>

<span *ngIf="template === displayType.Icon" (click)="onClickEnum()" (mouseover)="onHoverEnum()"><i [class]="icon" [style.color]="color"></i><span *ngIf="displayText" [ngStyle]="{ 'color': color}"> {{text}}</span></span>
